import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white text-neutral-900 antialiased flex flex-col">
      <Helmet>
        <title>Page not found — ScienceAI</title>
        <meta name="description" content="The page you’re looking for doesn’t exist." />
      </Helmet>

      <Nav />

      <main className="flex-1 grid place-items-center px-4 pt-28 pb-16">
        <div data-testid="not-found" className="max-w-[520px] text-center">
          <p className="text-[12px] uppercase tracking-[0.22em] font-medium text-neutral-500">
            Error · 404
          </p>
          <h1 className="mt-3 text-[40px] md:text-[56px] font-semibold tracking-[-0.02em] leading-[1.05] text-neutral-900">
            Page not found
          </h1>
          <p className="mt-4 text-[15px] md:text-[16px] text-neutral-600 leading-relaxed">
            We couldn’t find that page. It may have moved, or you may have followed a broken link.
          </p>
          <div className="mt-8">
            <Link
              to="/"
              data-testid="not-found-home-link"
              className="inline-flex items-center gap-2 rounded-full bg-neutral-900 px-6 h-11 text-[14px] font-medium text-white transition-all hover:bg-neutral-800 hover:gap-3"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to home
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
